import { useMenu } from "../menu";
import { empresaTemIA } from "./regras";

export function useAssistenteIA() {
  const { dadosEmpresa } = useMenu();

  return { iaDisponivel: empresaTemIA(dadosEmpresa?.id) };
}
